export default {"src":"/frontend-static/_next/static/media/secure-payment.cf876141.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};